module.exports = __webpack_public_path__ + "static/media/gallery-lg-1.8287f1d4.jpg";